import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { MistakesSection } from '../components/MistakesSection';
import { SolutionSection } from '../components/SolutionSection';
import { TransformationSection } from '../components/TransformationSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoItsFor } from '../components/WhoItsFor';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-navy text-cream overflow-x-hidden selection:bg-gold/30 selection:text-gold-bright" data-id="element-188">
      <Hero data-id="element-189" />
      <ProblemSection data-id="element-190" />
      <MistakesSection data-id="element-191" />
      <SolutionSection data-id="element-192" />
      <TransformationSection data-id="element-193" />
      <WhatYouGet data-id="element-194" />
      <WhoItsFor data-id="element-195" />
      <PricingCTA data-id="element-196" />
      <Footer data-id="element-197" />
    </main>;
}